import React, { useContext } from "react";
import styled, { css } from "styled-components";

import ImageGalleryContext from "context/image-gallery-context";

import Container from "partials/Container";
import AvailabilityChecker from "partials/AvailabilityChecker/RoomAvailabilityChecker";
import ActivityFeatures from "../Activities/SingleActivityPage/ActivityFeatures";
import FavoriteButton from "partials/FavoriteButton";
import GridElement from "partials/GridElement";

import Media from "css/Media";

export const PageHero = (props) => {
  const { open } = useContext(ImageGalleryContext);
  const { item, isMobile, fixed } = props;

  return (
    <Wrapper>
      {!isMobile && (
        <Container grid>
          <ImageGridElement
            image={item.acf.featured_image}
            absolute
            colStart={3}
            colEnd={22}
            rowStart={1}
          >
            <h1>{item.acf.item_name}</h1>
          </ImageGridElement>
          {item.type === "accommodation" ? (
            <AvailabilityGridElement
              colStart={4}
              colEnd={21}
              rowStart={2}
              id='availability-checker'
              isHidden={open}
            >
              {!fixed ? (
                <AvailabilityWrapper>
                  <AvailabilityChecker item={item} />
                </AvailabilityWrapper>
              ) : (
                <AvailabilityWrapper fixed>
                  <GridElement colStart={4} colEnd={21}>
                    <AvailabilityChecker item={item} />
                  </GridElement>
                </AvailabilityWrapper>
              )}
            </AvailabilityGridElement>
          ) : (
            <ActivityFeaturesGridElement colStart={1} colEnd={24} rowStart={2}>
              <ActivityFeatures isMobile={isMobile} data={item} />
            </ActivityFeaturesGridElement>
          )}
        </Container>
      )}
      {isMobile && (
        <Container mobileBleed grid>
          <ImageGridElement
            image={item.acf.featured_image}
            absolute
            colStart={1}
            colEnd={8}
            rowStart={1}
          ></ImageGridElement>
          <Hero colStart={1} colEnd={8} rowStart={2}>
            <Container grid>
              <GridElement colStart={1} colEnd={7} colSpan align='center'>
                <h1>{item.acf.item_name}</h1>
              </GridElement>
              <GridElement colStart={7} colEnd={8} place={["center", "end"]}>
                <FavoriteButton sort={item.type} item={item} />
              </GridElement>
            </Container>
          </Hero>
          <GridElement
            colStart={1}
            colEnd={8}
            rowStart={3}
            id='mobile-availability-checker'
          >
            {item.type === "accommodation" ? (
              <AvailabilityWrapper
                ref={props.forwardRef}
                fixed={fixed}
                isHidden={open}
              >
                <AvailabilityChecker fixed={fixed} item={item} />
              </AvailabilityWrapper>
            ) : (
              <ActivityFeatures isMobile={isMobile} data={item} />
            )}
          </GridElement>
        </Container>
      )}
    </Wrapper>
  );
};

export default PageHero;

const Wrapper = styled.div`
  height: calc(100vh - 134px);

  ${Media.greaterThan("m")`
        height: calc(100vh - 132px);
    `}

  ${Media.greaterThan("l")`
        height: calc(100vh - 149.5px);
    `}
`;

const Hero = styled(GridElement)`
  h1 {
    ${(props) => props.theme.fonts.h2}
    position: relative;
    padding: ${(props) => props.theme.spacing.contentL} 0;
  }
`;

const ImageGridElement = styled(GridElement)`
  height: calc(100vh - 440px);
  background-position: center;
  background-image: url(${(props) => props.image.sizes.full.url});
  background-repeat: no-repeat;
  background-size: cover;

  h1 {
    ${(props) => props.theme.fonts.h2}
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;

    ${Media.greaterThan("s")`
            padding: ${(props) => props.theme.spacing.contentL} ${(props) =>
      props.theme.spacing.elementXS};
            background: ${(props) => props.theme.colors.negative};
        `}
  }
  ${Media.greaterThan("s")`
        height: calc(100vh - 308px);
    `}
`;

const AvailabilityGridElement = styled(GridElement)`
  display: ${(p) => (p.isHidden ? "none" : "block")};
`;

const AvailabilityWrapper = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.negative};

  ${(props) =>
    props.fixed &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      z-index: 101;
      display: grid;
      grid-template-columns: repeat(11, 1fr 0.67fr) 1fr;
      padding: ${(props) => props.theme.spacing.elementXS} 25px;

      ${Media.lessThan("s")`
            display: ${(p) => (p.isHidden ? "none" : "block")};
            grid-template-columns: repeat(3, 1fr .67fr) 1fr;
            padding: ${(props) => props.theme.spacing.elementM} 25px;
        `}

      ${Media.greaterThan("m")`
            width: auto;
            padding: ${(props) => props.theme.spacing.elementXS} ${(props) =>
        props.theme.spacing.elementS};
            -ms-grid-columns: (1fr .435fr)[11] 1fr;
            grid-template-columns: repeat(11, 1fr .435fr) 1fr;
            max-width: 1680px;
            left: 60px;
            right: 60px;
        `}

        ${Media.greaterThan("l")`
            padding: ${(props) => props.theme.spacing.elementXS} ${(props) =>
        props.theme.spacing.elementL};
            left: 80px;
            right: 80px;
        `}

        ${Media.greaterThan("xl")`
            padding: ${(props) => props.theme.spacing.elementXS} 0;
            max-width: 1800px;
            left: calc((100vw - 1800px) /2);
        `}
    `}

  ${Media.greaterThan("s")`
        padding: ${(props) => props.theme.spacing.elementXS} 0;
    `}
`;

const ActivityFeaturesGridElement = styled(GridElement)`
  ${Media.greaterThan("s")`
        padding: ${(props) => props.theme.spacing.elementXS} 0;
    `}
`;
